export default {
    toggleFormState({ commit }, payload)
    {
        commit('toggleFormState', payload);
    },
}
